<template>
  <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
    <v-card-text class="d-flex justify-space-between">
      <v-container>
        <v-row v-if="perfil === PERFILES['ADMINSITRADOR GENERAL'] || perfil === PERFILES['Policia'] || perfil === PERFILES.RH_ADMINISTRADOR">
          <v-col class="d-flex align-center" cols="auto">
            <v-select
              v-model="gradoMaximoElegido"
              :items="tipoEstudios"
              item-value="title"
              item-text="title"
              label="Grado máximo de estudios"
              background-color="primary"
              color="secondary"
              rounded
              filled
              dense
              hide-details
              :loading="loadingCatalogo"
              :disabled="loadingCatalogo"
              style="min-width: 260px"
            />
            <TextButton
              class="ml-1"
              :loading="loadingGrado"
              :disabled="!gradoMaximoElegido || loadingGrado"
              @click="guardarGradoMaximo"
            >
              Guardar
            </TextButton>
          </v-col>
          <v-col align="right">
            <TextButton @click="openAgregarEstudio"> AGREGAR ESTUDIO </TextButton>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <estudios-table :estudios="estudios" :loading="loading" @edit="editarEstudio" />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<style scoped>
/* Estilos modernos para Estudios */
.ui-module-card {
  background: rgba(26, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.ui-module-card:hover {
  transform: translateY(-2px);
  border-color: rgba(var(--v-secondary-base-rgb), 0.4);
  box-shadow: 0 12px 48px rgba(var(--v-secondary-base-rgb), 0.2);
}

::v-deep .v-card-text {
  padding: 32px 24px !important;
  color: #e0e0e0 !important;
}

/* Select de grado de estudios */
::v-deep .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  box-shadow: none !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.45) !important;
}

::v-deep .v-input--is-focused .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
}

::v-deep .v-label {
  color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
}

::v-deep .v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-input .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
}
</style>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { DIALOG_TYPES } from '@/plugins/dialog-types'
import { PERFILES } from '@/perfiles.js'
import TextButton from '../../../base/TextButton.vue'
import EstudiosTable from '../../estudios/EstudiosTable.vue'

export default {
  components: {
    TextButton,
    EstudiosTable,
  },
  data() {
    return {
      PERFILES,
      DIALOG_TYPES,
      loading: false,
      loadingGrado: false,
      loadingCatalogo: false,
      gradoMaximoElegido: null,
    }
  },
  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
    ...mapGetters({
      perfil: 'getPerfil',
    }),
    ...mapGetters('estudio', {
      estudiosAll: 'getEstudios',
      tipoEstudios: 'getTipoEstudios',
    }),
    idPersonal() {
      return this.personal?.idPersonal
    },
    estudios() {
      return this.estudiosAll.filter((e) => e.fk_idPersonal == this.idPersonal)
    },
  },
  methods: {
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapMutations('estudio', ['SET_SELECTED_ESTUDIO']),
    ...mapActions('estudio', ['fetchEstudiosByPersonal', 'fetchTipoEstudios']),
    ...mapActions('personal', ['updatePersonal', 'fetchPersonalById']),

    async guardarGradoMaximo() {
      this.loadingGrado = true
      await this.updatePersonal({ ...this.personal, funcional: this.gradoMaximoElegido })
      await this.fetchPersonalById(this.idPersonal)
      this.loadingGrado = false
    },

    openAgregarEstudio() {
      this.SET_DIALOG({
        ...DIALOG_TYPES.AGREGAR_ESTUDIO,
        props: {
          id: this.idPersonal,
        },
      })
    },

    editarEstudio(estudio) {
      this.SET_SELECTED_ESTUDIO(estudio)
      this.SET_DIALOG(DIALOG_TYPES.EDITAR_ESTUDIO)
    },
  },
  async mounted() {
    this.loadingCatalogo = true
    await this.fetchTipoEstudios()
    this.loadingCatalogo = false
    this.gradoMaximoElegido = this.personal?.funcional || null
    if (this.idPersonal) {
      this.loading = true
      await this.fetchEstudiosByPersonal(this.idPersonal)
      this.loading = false
    }
  },
}
</script>
